import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { startLoadingExploreFeed } from '../../app/actions/statisticActions';
import { startLoadingCatalogModules } from '../../app/actions/catalogModuleActions';
import ExploreFeedCard from './ExploreFeedCard';

const MODULE_KEYS_BY_ID = {
  1: 'technology',
  2: 'alternative',
  3: 'experience',
  4: 'innovation',
  5: 'assistance',
  6: 'financial',
  7: 'vision',
  8: 'regulation',
};

const ExploreUdemyPanel = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const feed = useSelector((state) => state.statistic.exploreFeed);
  const { catalogModules } = useSelector((state) => state.catalogModule);
  const [catalogmodule_id, setCatalogmoduleId] = useState('');

  useEffect(() => {
    dispatch(startLoadingCatalogModules());
  }, [dispatch]);

  useEffect(() => {
    dispatch(startLoadingExploreFeed({ catalogmodule_id }));
  }, [dispatch, catalogmodule_id]);

  const moduleLabel = (key, fallback) =>
    key
      ? t(`semanticSearch.module.${key}`, { defaultValue: fallback || key })
      : fallback || '';

  const formatWhen = (value) => {
    if (!value) return '';
    try {
      return new Date(value).toLocaleString(i18n.language || 'es', {
        dateStyle: 'medium',
        timeStyle: 'short',
      });
    } catch (_e) {
      return String(value);
    }
  };

  const tabs = [{ id: '', key: '', name: t('semanticSearch.admin.event.all', { defaultValue: 'Todos' }) }].concat(
    (catalogModules || []).map((m) => {
      const key = MODULE_KEYS_BY_ID[m.id] || m.key || '';
      return {
        id: String(m.id),
        key,
        name: moduleLabel(key, m.name),
      };
    })
  );

  const empty = t('semanticSearch.explore.empty', { defaultValue: 'Aún no hay datos en este filtro.' });

  return (
    <div className="explore-udemy-panel container mt-4 mb-5">
      <h3 className="explore-udemy-panel__title">
        {t('semanticSearch.explore.title', { defaultValue: 'Explorar' })}
      </h3>
      <p className="text-muted small mb-3">
        {t('semanticSearch.explore.hint', {
          defaultValue: 'Textos y fichas más frecuentes. No se muestra quién buscó.',
        })}
      </p>
      <div className="d-flex flex-wrap gap-2 mb-4">
        {tabs.map((tab) => (
          <button
            key={tab.id || 'all'}
            type="button"
            className={`btn btn-sm ${String(catalogmodule_id) === String(tab.id) ? 'btn-dark' : 'btn-outline-dark'}`}
            onClick={() => setCatalogmoduleId(tab.id)}
          >
            {tab.name}
          </button>
        ))}
      </div>
      <div className="row g-4">
        <div className="col-md-4">
          <h5 className="explore-udemy-panel__col-title">
            {t('semanticSearch.explore.topSearched', { defaultValue: 'Lo más buscado' })}
          </h5>
          {(feed?.topSearches || []).length === 0 && <p className="text-muted small">{empty}</p>}
          {(feed?.topSearches || []).map((row) => (
            <ExploreFeedCard
              key={row.text}
              title={row.text}
              meta={t('semanticSearch.explore.searchCount', {
                defaultValue: '{{count}} búsquedas',
                count: row.count,
              })}
              badge={row.count}
            />
          ))}
        </div>
        <div className="col-md-4">
          <h5 className="explore-udemy-panel__col-title">
            {t('semanticSearch.explore.recent', { defaultValue: 'Últimas búsquedas' })}
          </h5>
          {(feed?.lastSearches || []).length === 0 && <p className="text-muted small">{empty}</p>}
          {(feed?.lastSearches || []).map((row, i) => (
            <ExploreFeedCard
              key={`${row.text}-${row.created_at}-${i}`}
              title={row.text}
              chip={moduleLabel(row.module_key)}
              meta={formatWhen(row.created_at)}
            />
          ))}
        </div>
        <div className="col-md-4">
          <h5 className="explore-udemy-panel__col-title">
            {t('semanticSearch.explore.topFound', { defaultValue: 'Lo más encontrado' })}
          </h5>
          {(feed?.topFound || []).length === 0 && <p className="text-muted small">{empty}</p>}
          {(feed?.topFound || []).map((row) => (
            <ExploreFeedCard
              key={`${row.module_key}-${row.target_reference_id}`}
              title={row.name || t('semanticSearch.explore.unnamed', { defaultValue: 'Caso sin nombre' })}
              chip={moduleLabel(row.module_key)}
              subtitle={row.code
                ? t('semanticSearch.explore.code', {
                    defaultValue: 'Código {{code}}',
                    code: row.code,
                  })
                : null}
              meta={t('semanticSearch.explore.foundCount', {
                defaultValue: '{{count}} veces en resultados',
                count: row.count,
              })}
              badge={row.count}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExploreUdemyPanel;
